module.exports = __webpack_public_path__ + "img/login-banner.d9adabb9.png";